import { LIFECYCLE_STATE_VALUES } from "../lifecycleStates";
import type { LifecycleState } from "../types";

// Espejo de las 3 reglas del backend en validateStateTransition (no es una tabla
// enumerada — el backend acepta cualquier transición que no caiga en estas reglas).
// Drift-guard test importa validateStateTransition del backend y verifica match.
// Ver internal/decisions-log.md.

export const TERMINAL_LIFECYCLE_STATES: LifecycleState[] = ["dead", "sold", "culled_for_sale"];

export function isTerminalLifecycleState(state: LifecycleState): boolean {
  return TERMINAL_LIFECYCLE_STATES.includes(state);
}

export function getAvailableNextStates(from: LifecycleState): LifecycleState[] {
  if (isTerminalLifecycleState(from)) return [];
  return LIFECYCLE_STATE_VALUES.filter(
    (to) => to !== "registered" && to !== from,
  ) as LifecycleState[];
}
